/* eslint-disable no-redeclare */
export function reverseArr(input) {
    var ret = [];
    for (var i = input.length - 1; i >= 0; i--) {
        ret.push(input[i]);
    }
    return ret;
}

export function SampleNextArrow(props) {
    const { className, onClick, theme } = props;

    return (
        <div
            className={className}
            onClick={onClick}
        >
            <div className='d-flex justify-content-center align-items-center' style={{ width: 32, height: 24, borderRadius: '0px 12.0471px 12.0471px 0px', border: '0.752941px solid #9D99BF', background: className.includes('slick-disabled') ? '#fff' : theme }}>
                {className.includes('slick-disabled') ? <img src="/images/chevron-right.svg" width='16px' alt='' /> : <img src="/images/chevron-right-white.svg" width='16px' alt='' />}
            </div>
        </div>
    );
}

export function SamplePrevArrow(props) {
    const { className, onClick, theme } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <div className='d-flex justify-content-center align-items-center' style={{ width: 32, height: 24, borderRadius: '0px 12.0471px 12.0471px 0px', transform: 'matrix(-1, 0, 0, 1, 0, 0)', border: '0.752941px solid #9D99BF', background: className.includes('slick-disabled') ? '#fff' : theme }}>
                {className.includes('slick-disabled') ? <img src="/images/chevron-right.svg" width='16px' alt='' /> : <img src="/images/chevron-right-white.svg" width='16px' alt='' />}
            </div>
        </div>
    );
}

export const nFormatter = (num) => {
    var si = [
        { value: 1, symbol: "" },
        { value: 1E3, symbol: "k" },
        { value: 1E6, symbol: "M" },
        { value: 1E9, symbol: "G" },
        { value: 1E12, symbol: "T" },
        { value: 1E15, symbol: "P" },
        { value: 1E18, symbol: "E" }
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }
    return (num / si[i].value).toFixed(1).replace(rx, "$1") + si[i].symbol;
}

export const renameProperties = (sourceObj, replaceList, destObj) => {
    destObj = destObj || {};
    each(sourceObj, function (key) {
        if (sourceObj.hasOwnProperty(key)) {
            if (typeof sourceObj[key] === 'object') {
                if (replaceList[key]) {
                    var newName = replaceList[key];
                    destObj[newName] = {};
                    renameProperties(sourceObj[key], replaceList, destObj[newName]);
                } else if (!replaceList[key]) {
                    destObj[key] = {};
                    renameProperties(sourceObj[key], replaceList, destObj[key]);
                }
            } else {
                if (replaceList[key]) {
                    var newName = replaceList[key];
                    destObj[newName] = sourceObj[key];
                } else if (!replaceList[key]) {
                    destObj[key] = sourceObj[key];
                }
            }
        }
    });

    return destObj;
}
function each(objOrArr, callBack) {
    if (objOrArr instanceof Array) {
        for (var i = 0; i < objOrArr.length; i++) {
            callBack(i);
        }
    } else if (typeof objOrArr === 'object') {
        for (var prop in objOrArr) {
            // if the property really exist
            if (objOrArr.hasOwnProperty(prop)) {
                callBack(prop);
            }
        }
    }
}

export const renameArrProperties = (arr) => {
    console.log(arr)
    var newArr = [];
    for (var i = 0; i < arr.length; i++) {
        var obj = {};
        obj.label = arr[i];
        obj.value = arr[i]
        newArr.push(obj);
    }
    console.log(newArr)
    return newArr
}



export const secondsToTime1 = (e) => {
    // var h = Math.floor(e / 3600).toString().padStart(2,'0'),
    var m = Math.floor(e % 3600 / 60).toString().padStart(2, '0'),
        s = Math.floor(e % 60).toString().padStart(2, '0');

    return m + ':' + s;
    //return `${h}:${m}:${s}`;
}

export const convertDate = (d1) => {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const date = new Date(d1)
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(date)
    return [pad(d.getDate()), pad(monthNames[d.getMonth()]), pad(d.getFullYear())].join('-')
}

export const formatAMPM = (d) => {
    var date = new Date(d)
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

export function validatePhone(txtPhone) {
    var filter = /[6-9]{1}[0-9]{9}/;
    if (filter.test(txtPhone)) {
        return true;
    }
    else {
        return false;
    }
}


export const checkDateDifference = (date) => {
    if (date !== null) {
        let end = new Date(date)
        let today = new Date()
        if (today >= end) {
            return true
        }
        else {
            return false
        }
    }
    else {
        return false
    }

}
export function convertToDates(str) {
    var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
}

export function convertToDate(str) {
    var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("/");
}

export function secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
        h: hours,
        m: (minutes < 10 ? "0" : "") + minutes,
        s: (seconds < 10 ? "0" : "") + seconds,
    };
    return obj;
}

export function generate_year_range(start, end) {
    var years = [];
    for (var year = start; year <= end; year++) {
        years.push(year);
    }
    return years;
}

export function generateNumbers(n) {
    let numbers = [];
    for (let i = 1; i <= n; i++) {
        numbers.push(i);
    }
    return numbers;
}


export const convertMinsToHrsMins = (num) => {
    var hours = Math.floor(num / 60);
    var minutes = num % 60;
    return minutes === 0 ? minutes > 1 ? hours + 1 : hours + " hrs " : hours === 0 ? minutes + " mins " : hours + " hrs ";
}

// used in skill/explorer
export const getViewed = (arr) => {
    let len = arr.length;
    let viewed = arr.filter(el => el.viewed === true).length
    let percent = Math.round((viewed / len) * 100)
    return percent
}

export function padLeadingZeros(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
}

export const getDays = (d1) => {
    d1.setHours(12);
    let d2 = new Date(d1.setDate(d1.getDate() + 9));
    let difference = d2.getTime() - new Date().getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
}

export const base64ToFile = (base64String, filename) => {
    console.log(base64String)
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};